export class MapLocation {
  constructor(name, x, y, url, description) {
    this.name = name;
    this.x = x;
    this.y = y;
    this.url = url
    this.desc = description
  }
}
